import React, {useCallback, useRef, useState} from 'react'
import {gql, useLazyQuery} from '@apollo/client'
import useEffect from 'admin/hooks/useEffect'

const QUERY = gql`
  query GetAccountsForGlobalAccountField($search: String) {
    globalAccounts(q: $search) {
      id
      displayName @client
      contactFullName @client
      name
      contactFirstName
      contactLastName
      state
      organisation {
        id
        internalName
        internalColor
      }
    }
  }
`

export default () => {
  const ref = useRef()
  const [showList, setShowList] = useState(false)
  const [search, setSearch] = useState('')

  useEffect(() => {
    const handleExit = ({target: clickedElement}) => {
      if (ref.current && !ref.current.contains(clickedElement)) {
        setShowList(false)
      }
    }

    document.addEventListener('click', handleExit)
    return () => document.removeEventListener('click', handleExit)
  }, [])

  const [getAccounts, {data: {globalAccounts = []} = {}}] = useLazyQuery(QUERY)

  const handleSearch = e => {
    const value = e.target.value
    getAccounts({variables: {search: value}})
    setShowList(true)
  }
  const debouncedHandleChange = useCallback(_.debounce(handleSearch, 800), [])
  const handleChange = e => {
    e.preventDefault()
    const value = e.target.value
    setSearch(value)
    if (value && value.length) {
      debouncedHandleChange(e)
    } else {
      setShowList(false)
    }
  }

  return (
    <div style={{width: '100%'}} className={`dropdown ${showList ? 'is-active' : ''}`}>
      <div style={{width: '100%'}} className='dropdown-trigger'>
        <div className='field is-horizontal mx-4' style={{alignItems: 'normal'}}>
          <div className='field-label is-small p-0'>
            <label className='label has-text-white' htmlFor='account-search'>
              Find
            </label>
          </div>
          <div className='field-body'>
            <div className='field'>
              <div className='control'>
                <input
                  ref={ref}
                  value={search}
                  onChange={handleChange}
                  style={{verticalAlign: 'baseline'}}
                  name='account-search'
                  id='account-search'
                  className='input is-normal is-burgundy-inverted'
                  type='text'
                  aria-controls='accounts-list'
                  aria-haspopup='true'
                  autoComplete='off'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {globalAccounts.length ? (
        <div className='dropdown-menu' id='accounts-list' role='menu'>
          <div className='dropdown-content' ref={ref}>
            {globalAccounts.map((account, i) => {
              const color = account.organisation.internalColor ? `#${account.organisation.internalColor}` : undefined
              const style = color ? {borderLeft: `6px solid ${color}`} : {}
              return (
                <a
                  key={i}
                  href={`/orgs/${account.organisation.id}/accounts/${account.id}`}
                  className='dropdown-item'
                  style={style}>
                  {account.displayName}{' '}
                  {account.displayName !== account.contactFullName && !!account.contactFullName ? (
                    <span>({account.contactFullName})</span>
                  ) : null}
                  <sub className='has-text-weight-semibold' style={{color}}>
                    {account.organisation.internalName}
                  </sub>
                </a>
              )
            })}
          </div>
        </div>
      ) : null}
    </div>
  )
}
